import { Component, OnInit } from '@angular/core';
import { ServiceDashboardService } from 'src/app/portal/service-dashboard/service-dashboard.service';

@Component({
    selector: 'seo-dashboard',
    templateUrl: './seo-dashboard.component.html',
    styleUrls: ['./seo-dashboard.component.scss'],
    standalone: false
})
export class SeoDashboardComponent implements OnInit {
  constructor(public dashboardService: ServiceDashboardService) { }

  ngOnInit(): void {
  }

  get seoChartData() {
    return this.dashboardService.website?.seoChartData && this.dashboardService.website.seoChartData.length
      ? [...this.dashboardService.website.seoChartData, this.dashboardService.website.commitHistoryChartData, this.dashboardService.website.contractDatesChartData]
      : [this.dashboardService.website?.commitHistoryChartData, this.dashboardService.website?.contractDatesChartData];
  }
}
